import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export default function NavTabs() {
  const location = useLocation();
  const [value, setValue] = useState(0);
  const profile = useSelector((state) => state.firebase.profile);

  const isAdmin = profile && profile.claims && profile.claims.includes('admin');
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const style = {
    color: 'black',
  };

  useEffect(() => {
    // Define las URL y sus valores iniciales correspondientes
    const urlValueMap = {
      '/dashboard': 0,
      '/dashboard/prices': 1,
      '/dashboard/graphics': 2,
      '/dashboard/prepaid': 3,
    };

    // Obtén el valor inicial basado en la URL actual
    const initialValue = urlValueMap[location.pathname];
    if (initialValue !== undefined) {
      setValue(initialValue);
    }
  }, [location.pathname]);
  return (
    <Box sx={{ width: '100%', mt: '64px' }}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="nav tabs example"
        centered
        TabIndicatorProps={{ style: { background: 'yellow' } }}
      >
        <Tab component={Link} label="Facturacion" to="/dashboard" style={style} />
        {isAdmin && <Tab component={Link} label="Precios" to="/dashboard/prices" style={style} />}
        <Tab component={Link} label="Graficos" to="/dashboard/graphics" style={style} />
        {isAdmin && <Tab component={Link} label="Prepago" to="/dashboard/prepaid" style={style} />}
      </Tabs>
    </Box>
  );
}
